class Builder {
    constructor() {
        this.state = {
            braceletSize: 16,
            baseColor: 'Silver', // Default color
            optionSet: null,
            dragSrcEl: null,
            charmQuantities: new Map(),
            BLANK_CHARM_PRICE: 2,
            ICON_CHARM_PRICE: 5,
            touchDragItem: null,
            touchDragGhost: null,
            blankImages: {
                'Silver': '//thenicheshop.co/cdn/shop/files/Blank_8502ee62-8e2e-441e-9013-dcc76824a858.png?v=1759484855',
                'Gold': 'https://cdn.shopify.com/s/files/1/0539/0984/8234/files/Gold_Blank_1_-cutout.png?v=1784025919'
            }
        };

        this.init();
    }

    init() {
        document.addEventListener("DOMContentLoaded", () => {
            this.handleHulkLoad();
            this.handleAddToCart();
        });
    }

    handleHulkLoad() {
        const polling = setInterval(() => {
            const optionSet = document.querySelector(".hulkapps_option_set");
            if (optionSet) {
                clearInterval(polling);
                setTimeout(() => this.main(optionSet), 100);
            }
        }, 100);

        setTimeout(() => clearInterval(polling), 20000);
    }

    main(optionSet) {
        this.state.optionSet = optionSet;
        
        this.initColorSelection();

        const dropdown = this.state.optionSet.querySelector(".bracelet_size select");
        if (dropdown) {
            this.setBraceletSize(dropdown);
            dropdown.addEventListener("change", e => {
                this.setBraceletSize(e.target);
            });
        }

        this.encapsulateCategoriesAndCharms();
        this.handleCharmSelect();
        this.handleCategorySelect();
        this.handleSearch(); 
        this.initDropZones();
        this.attachCategoriesTitles();
        this.showBuilder();
        this.handleBuilderStickyPosition();
        this.handleShareFeature();
        this.loadStateFromURL();
    }

    initColorSelection() {
        // Attempt to find an existing color select (if configured in HulkApps)
        let colorDropdown = this.state.optionSet.querySelector(".bracelet_color select");

        if (!colorDropdown) {
            const sizeWrapper = this.state.optionSet.querySelector(".bracelet_size");
            if (sizeWrapper) {
                const colorWrapper = document.createElement("div");
                colorWrapper.className = "hulkapps_option bracelet_color";
                colorWrapper.style.marginBottom = "15px";
                colorWrapper.innerHTML = `
                    <label class="hulkapps_option_name">Choose Bracelet Color</label>
                    <select class="hulkapps_option_value">
                        <option value="Silver" selected>Silver</option>
                        <option value="Gold">Gold</option>
                    </select>
                `;
                sizeWrapper.parentNode.insertBefore(colorWrapper, sizeWrapper);
                colorDropdown = colorWrapper.querySelector("select");
            }
        }

        if (colorDropdown) {
            this.setBraceletColor(colorDropdown.value);
            colorDropdown.addEventListener("change", (e) => {
                this.setBraceletColor(e.target.value);
            });
        }
    }

    setBraceletColor(color) {
        this.state.baseColor = color.includes('Gold') ? 'Gold' : 'Silver';

        // Update all existing blanks to the new color image
        const container = document.getElementById("builder-container");
        if (container) {
            const blanks = container.querySelectorAll('.builder-element[data-type="Blank"] img');
            blanks.forEach(img => {
                img.src = this.state.blankImages[this.state.baseColor];
            });
        }

        this.filterCharmsByDefaultColor(this.state.baseColor);
    }

    filterCharmsByDefaultColor(color) {
        const searchInput = document.getElementById("charms-search");
        if (searchInput) searchInput.value = ""; 

        const isGoldSelected = color.toLowerCase() === 'gold';
        
        // 1. Get all charms and their parent container
        const charms = Array.from(this.state.optionSet.querySelectorAll(".icon_charm"));
        if (!charms.length) return;
        const parent = charms[0].parentNode;

        // 2. Sort charms so the selected color comes first
        charms.sort((a, b) => {
            const labelElA = a.firstElementChild;
            const labelElB = b.firstElementChild;
            
            const labelA = labelElA ? labelElA.getAttribute("aria-label").trim().toLowerCase() : "";
            const labelB = labelElB ? labelElB.getAttribute("aria-label").trim().toLowerCase() : "";
            
            const aIsGold = labelA.endsWith("gold");
            const bIsGold = labelB.endsWith("gold");

            // Check if the charm matches the currently selected base color
            const aMatchesColor = isGoldSelected ? aIsGold : !aIsGold;
            const bMatchesColor = isGoldSelected ? bIsGold : !bIsGold;

            if (aMatchesColor && !bMatchesColor) return -1; // a comes first
            if (!aMatchesColor && bMatchesColor) return 1;  // b comes first
            return 0; // keep original order
        });

        // 3. Re-append in the sorted order and ensure they are all visible
        charms.forEach(charm => {
            parent.appendChild(charm);
            charm.style.display = "flex"; 
        });
    }

    handleSearch() {
        const searchInput = document.getElementById("charms-search");
        if (!searchInput) return;

        const debouncedFilter = this.debounce((query) => {
            this.state.optionSet.querySelectorAll(".icon_charm").forEach(charm => {
                const nameLabel = charm.firstElementChild;
                if (!nameLabel) return;

                const charmName = nameLabel.getAttribute("aria-label").trim().toLowerCase();

                if (charmName.includes(query)) {
                    charm.style.display = "flex";
                } else {
                    charm.style.display = "none";
                }
            });
        }, 300);

        searchInput.addEventListener("input", (e) => {
            const query = e.target.value.toLowerCase().trim();
            debouncedFilter(query);
        });

        searchInput.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
            }
        });
    }

    handleShareFeature() {
        const atcSection = document.querySelector(".atc-section") || document.getElementById("builder");
        if (!atcSection) return;

        const shareBtn = document.createElement("button");
        shareBtn.type = "button";
        shareBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#d93f42" fill="none" stroke="#d93f42" stroke-width="2" stroke-linecap="round"><path d="M9.5 14.5L14.5 9.49995" /><path d="M16.8463 14.6095L19.4558 12C21.5147 9.94108 21.5147 6.60298 19.4558 4.54411C17.397 2.48524 14.0589 2.48524 12 4.54411L9.39045 7.15366M14.6095 16.8463L12 19.4558C9.94113 21.5147 6.60303 21.5147 4.54416 19.4558C2.48528 17.3969 2.48528 14.0588 4.54416 12L7.1537 9.39041" /></svg>Share Design`;
        shareBtn.className = "share-btn";

        shareBtn.addEventListener("click", () => {
            this.copyShareLink(shareBtn);
        });

        const target = atcSection.querySelector("div");
        if (target && target.parentNode) {
            target.parentNode.insertBefore(shareBtn, target.nextSibling);
        } else {
            atcSection.appendChild(shareBtn);
        }
    }

    generateShareURL() {
        const charmsList = document.querySelectorAll(".builder-element");
        const charmIds = [];

        charmsList.forEach(charm => {
            const type = charm.dataset.type;
            charmIds.push(encodeURIComponent(type));

            if (type !== "Blank") {
                const charmInput = this.state.optionSet.querySelector(`.hulkapps_option.swatch_render > div[aria-label="${type}"] + div input[type="hidden"]`);
                if (charmInput && charmInput.value.includes("undefined")) {
                    charmInput.value = charmInput.value.replace("undefined", "Icon Charm [ $5 ]");
                }
            }
        });

        const params = new URLSearchParams();
        params.set('color', this.state.baseColor);
        params.set('size', this.state.braceletSize);
        params.set('charms', charmIds.join(','));

        return `${window.location.origin}${window.location.pathname}?${params.toString()}`;
    }

    updateShareInput() {
        const input = document.querySelector("input[type='hidden'][name='properties[Share Link]']");
        if (input) {
            input.value = this.generateShareURL();
        }
    }

    copyShareLink(btnElement) {
        const shareUrl = this.generateShareURL();

        navigator.clipboard.writeText(shareUrl).then(() => {
            const originalHTML = btnElement.innerHTML;
            btnElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#d93f42" fill="none" stroke="#d93f42" stroke-width="2" stroke-linecap="round"><path d="M9.5 14.5L14.5 9.49995" /><path d="M16.8463 14.6095L19.4558 12C21.5147 9.94108 21.5147 6.60298 19.4558 4.54411C17.397 2.48524 14.0589 2.48524 12 4.54411L9.39045 7.15366M14.6095 16.8463L12 19.4558C9.94113 21.5147 6.60303 21.5147 4.54416 19.4558C2.48528 17.3969 2.48528 14.0588 4.54416 12L7.1537 9.39041" /></svg>Link Copied!`;
            setTimeout(() => btnElement.innerHTML = originalHTML, 2000);
        }).catch(err => {
            console.error('Failed to copy: ', err);
            alert("Could not copy link automatically. Here is your link:\n" + shareUrl);
        });
    }

    loadStateFromURL() {
        const params = new URLSearchParams(window.location.search);
        const colorParam = params.get('color');
        const sizeParam = params.get('size');
        const charmsParam = params.get('charms');

        if (colorParam) {
            let colorDropdown = this.state.optionSet.querySelector(".bracelet_color select");
            if (colorDropdown) {
                colorDropdown.value = colorParam;
                this.setBraceletColor(colorParam);
            }
        }

        if (!sizeParam || !charmsParam) return;

        const dropdown = this.state.optionSet.querySelector(".bracelet_size select");
        if (dropdown) {
            dropdown.value = dropdown.querySelector(`option[value*="${sizeParam}"]`)?.value || dropdown.value;
            this.setBraceletSize(dropdown);
        }

        const charmNames = charmsParam.split(',').map(decodeURIComponent);
        const builderContainer = document.getElementById("builder-container");
        const slots = builderContainer.querySelectorAll(".builder-element");

        const availableCharms = {};
        this.state.optionSet.querySelectorAll(".icon_charm .hulkapps_option_value").forEach(charmEl => {
            const name = charmEl.previousElementSibling.getAttribute("aria-label");
            const img = charmEl.querySelector("input[type='radio']").dataset.image;
            const quantityInput = charmEl.querySelector("input[type='number']");
            const hiddenInput = charmEl.querySelector(".hulk_swatch_hidden_prop");

            availableCharms[name] = { img, quantityInput, hiddenInput };
        });

        charmNames.forEach((charmName, index) => {
            if (index >= slots.length) return;
            if (charmName === "Blank") return;

            if (availableCharms[charmName]) {
                const slot = slots[index];
                const { img, quantityInput, hiddenInput } = availableCharms[charmName];

                this.replaceCharm(slot, img, charmName);

                if (!this.state.charmQuantities.has(charmName)) {
                    this.state.charmQuantities.set(charmName, 0);
                }
                this.state.charmQuantities.set(charmName, this.state.charmQuantities.get(charmName) + 1);

                const currentQuantity = this.state.charmQuantities.get(charmName);

                if (quantityInput) {
                    quantityInput.value = currentQuantity;
                    quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
                }

                if (hiddenInput) {
                    const base = hiddenInput.value.split("|")[0].trim();
                    hiddenInput.value = `${base} | ${currentQuantity}`;
                }
            }
        });

        this.updateReceipt();
    }

    setBraceletSize(dropdown) {
        const match = dropdown.value.match(/\d+/);
        const size = match ? parseInt(match[0], 10) : null;

        this.state.braceletSize = size;

        const builderContainer = document.getElementById("builder-container");
        const currentBraceletSize = builderContainer.querySelectorAll(".builder-element").length;

        if (size === currentBraceletSize) {
            this.updateReceipt();
            return;
        } else if (size > currentBraceletSize) {
            for (let i = 0; i < size - currentBraceletSize; i++) {
                builderContainer.appendChild(this.createBlankCharm());
            }
        } else {
            for (let i = 0; i < currentBraceletSize - size; i++) {
                builderContainer.querySelector(".builder-element:last-child").remove();
            }
        }

        this.updateReceipt();
    }

    updateReceipt() {
        const icons = document.querySelectorAll(".builder-element.icon").length;
        const blanks = this.state.braceletSize - icons;

        const blanksCost = blanks * this.state.BLANK_CHARM_PRICE;
        const totalCost = blanksCost + icons * this.state.ICON_CHARM_PRICE;

        const atcSection = document.querySelector(".atc-section");
        if (atcSection) {
            atcSection.querySelector(".cost").textContent = `$${parseFloat(totalCost).toFixed(2)}`;
            atcSection.querySelector(".blanks span:nth-child(1)").textContent = blanks;
            atcSection.querySelector(".icons span:nth-child(1)").textContent = icons;
        }

        const input = this.state.optionSet.querySelector(".base_charms input");
        if (input) input.value = blanks;
        input.dispatchEvent(new Event("change", { bubbles: true }));

        const charmsList = document.querySelectorAll(".builder-element");

        let charmsOrder = "";
        charmsList.forEach((charm, i) => {
            charmsOrder += `Charm ${i + 1}: ${charm.dataset.type} | `;
        });

        const charmsOrderInput = this.state.optionSet.querySelector(".charms_order input[type='hidden']");
        if (charmsOrderInput) charmsOrderInput.value = charmsOrder;

        // if (input) input.value = `Base: ${this.state.baseColor} | ${charmsOrder} [${blanksCost}]`;

        this.updateShareInput();
    }

    handleCharmSelect() {
        const charmQuantities = this.state.charmQuantities;

        const runCharmLogic = this.debounce((charm, targetBuilderElement, imgSrc, value) => {
            this.replaceCharm(targetBuilderElement, imgSrc, value);

            if (!charmQuantities.has(value)) {
                charmQuantities.set(value, 1);
            } else {
                charmQuantities.set(value, charmQuantities.get(value) + 1);
            }

            const currentQuantity = charmQuantities.get(value);

            const quantityInput = charm.querySelector("input[type='number']");
            if (quantityInput) {
                quantityInput.value = currentQuantity;
                quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
            }

            const hiddenInput = charm.querySelector(".hulk_swatch_hidden_prop");
            if (hiddenInput) {
                const base = hiddenInput.value.split("|")[0].trim();
                hiddenInput.value = `${base} | ${currentQuantity}`;
            }

            this.updateReceipt();
        }, 10);

        this.state.optionSet.querySelectorAll(".icon_charm .hulkapps_option_value").forEach(charm => {
            charm.addEventListener("click", e => {
                const targetBuilderElement = document.querySelector(".builder-element:not(.icon)");

                if (!targetBuilderElement) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }

                const imgSrc = charm.querySelector("input[type='radio']").dataset.image;
                const value = charm.previousElementSibling.getAttribute("aria-label");

                runCharmLogic(charm, targetBuilderElement, imgSrc, value);
            });
        });
    }

    handleCategorySelect() {
        if (typeof window.charmsByCategory === 'undefined') return;

        // 1. Map written numbers to integers for sorting
        const numberWordMap = {
            'zero': 0, 'one': 1, 'two': 2, 'three': 3, 'four': 4,
            'five': 5, 'six': 6, 'seven': 7, 'eight': 8, 'nine': 9, 'ten': 10
        };

        // Helper function to find the numeric value of a charm's label
        const getNumberValue = (label) => {
            const lowerLabel = label.toLowerCase();
            for (const [word, num] of Object.entries(numberWordMap)) {
                // Word boundary (\b) ensures we match "one" and not "stone" or "bone"
                const regex = new RegExp(`\\b${word}\\b`, 'i');
                if (regex.test(lowerLabel)) return num;
            }
            return 999; // Non-number charms go to the end if accidentally included
        };

        this.state.optionSet.querySelectorAll(".categories label > div").forEach(category => {
            category.addEventListener("click", () => {
                const searchInput = document.getElementById("charms-search");
                if (searchInput) searchInput.value = ""; 

                const value = category.parentElement.getAttribute("aria-label").trim().toLowerCase().replace("-", "_").replace(" ", "_");
                console.log(value);

                const charms = Array.from(this.state.optionSet.querySelectorAll(".icon_charm"));
                if (!charms.length) return;

                // 2. If 'numbers' category is selected, sort the DOM elements
                if (value === "numbers") {
                    const parent = charms[0].parentNode;
                    
                    charms.sort((a, b) => {
                        const labelA = a.firstElementChild ? a.firstElementChild.getAttribute("aria-label").trim() : "";
                        const labelB = b.firstElementChild ? b.firstElementChild.getAttribute("aria-label").trim() : "";
                        return getNumberValue(labelA) - getNumberValue(labelB);
                    });

                    // Re-append elements to the DOM in their new sorted order
                    charms.forEach(charm => parent.appendChild(charm));
                }

                // 3. Apply display filtering
                charms.forEach(charm => {
                    const exactLabel = charm.firstElementChild.getAttribute("aria-label").trim();
                    
                    // Added optional chaining (?.) as a safe check in case the category array is undefined
                    const matchesCategory = value === "all" || (window.charmsByCategory[value] && window.charmsByCategory[value].includes(exactLabel));

                    if (matchesCategory) {
                        charm.style.display = "flex";
                    } else {
                        charm.style.display = "none";
                    }
                });
            });
        });
    }

    encapsulateCategoriesAndCharms() {
        const categories = document.querySelector(".categories");

        if (categories) {
            const wrapperMain = document.createElement("div");
            wrapperMain.className = "charms-main-container";

            const wrapperBelow = document.createElement("div");
            wrapperBelow.className = "charms-all";

            const wrapperCharms = document.createElement("div");
            categories.parentNode.insertBefore(wrapperMain, categories);

            wrapperMain.appendChild(categories);
            wrapperMain.appendChild(wrapperBelow);
            
            const charmsTitle = document.createElement("div");
            charmsTitle.textContent = "Charms";
            charmsTitle.className = "charms-title";

            const searchInput = document.createElement("input");
            searchInput.type = "search";
            searchInput.placeholder = "Search charms...";
            searchInput.autocomplete = "off";
            searchInput.id = "charms-search";

            wrapperBelow.appendChild(charmsTitle);
            wrapperBelow.appendChild(searchInput);
            wrapperBelow.appendChild(wrapperCharms);

            let el = wrapperMain.nextElementSibling;

            while (el) {
                const next = el.nextElementSibling;
                wrapperCharms.appendChild(el);
                el = next;
            }
        }
    }

    createBlankCharm() {
        const div = document.createElement("div");
        div.className = "builder-element";
        div.setAttribute("data-type", "Blank");

        const img = document.createElement("img");
        // Utilize the dynamic blank image state based on color selection
        img.src = this.state.blankImages[this.state.baseColor];
        img.alt = "";
        img.draggable = false;

        div.appendChild(img);

        this.initDropZones();

        return div;
    }

    replaceCharm(element, imgSrc, value) {
        const container = document.getElementById("builder-container");

        if (imgSrc) {
            const newIcon = document.createElement("div");
            newIcon.className = "builder-element icon";
            newIcon.setAttribute("data-type", value);

            const img = document.createElement("img");
            img.src = imgSrc;
            img.alt = value;
            newIcon.appendChild(img);

            const removeBtn = document.createElement("button");
            removeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none"><path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path d="M9.5 16.5L9.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path d="M14.5 16.5L14.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>`;

            const dragIcon = document.createElement("div");
            dragIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none"><path d="M5 9C4.39316 9.58984 2 11.1597 2 12C2 12.8403 4.39316 14.4102 5 15" stroke="#d93f42" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M19 9C19.6068 9.58984 22 11.1597 22 12C22 12.8403 19.6068 14.4102 19 15" stroke="#d93f42" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M2.42285 11.9795H21.868" stroke="#d93f42" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`;

            newIcon.appendChild(removeBtn);
            newIcon.appendChild(dragIcon);

            container.replaceChild(newIcon, element);

            this.makeDraggable(newIcon);
            this.attachRemoveEvent(newIcon);

        } else {
            const newBlank = this.createBlankCharm();
            container.replaceChild(newBlank, element);
        }

        this.initDropZones();
    }

    attachRemoveEvent(element) {
        const removeBtn = element.querySelector("button");
        if (!removeBtn) return;

        removeBtn.addEventListener("pointerdown", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const targetBuilderElement = e.target.closest(".builder-element");
            const value = targetBuilderElement.dataset.type;

            this.replaceCharm(targetBuilderElement);

            const quantityInput = this.state.optionSet.querySelector(`.icon_charm > div[aria-label="${value}"] + div input[type="number"]`);
            if (quantityInput) {
                const hiddenInput = quantityInput.nextElementSibling;
                const quantity = parseInt(quantityInput.value);

                if (quantity > 1) {
                    quantityInput.value = quantity - 1;
                    this.state.charmQuantities.set(value, this.state.charmQuantities.get(value) - 1);

                    if (hiddenInput) {
                        const base = hiddenInput.value.split("|")[0].trim();
                        hiddenInput.value = `${base} | ${quantity - 1}`;
                    }
                } else {
                    quantityInput.value = 0;
                    if (hiddenInput) hiddenInput.value = "";
                    this.state.charmQuantities.set(value, 0);
                }
            }
            this.updateReceipt();
        });
    }

    makeDraggable(element) {
        element.setAttribute("draggable", "true");

        element.addEventListener("dragstart", (e) => {
            e.dataTransfer.effectAllowed = "move";
            const container = document.getElementById("builder-container");
            const index = Array.from(container.children).indexOf(element);
            e.dataTransfer.setData("text/plain", index);
            element.classList.add("dragging");
        });

        element.addEventListener("dragend", () => {
            element.classList.remove("dragging");
        });

        this.initTouchEvents(element);
    }

    initTouchEvents(element) {
        element.addEventListener("touchstart", (e) => {
            if (e.target.closest('button')) return;

            this.state.touchDragItem = element;
            element.classList.add("dragging");

            const ghost = element.cloneNode(true);
            ghost.classList.add("touch-ghost");
            ghost.style.position = "fixed";
            ghost.style.zIndex = "10000";
            ghost.style.pointerEvents = "none";
            ghost.style.opacity = "0.8";
            ghost.style.width = element.offsetWidth + "px";
            ghost.style.height = element.offsetHeight + "px";
            ghost.style.transition = "none";

            const touch = e.touches[0];
            ghost.style.left = (touch.clientX - (element.offsetWidth / 2)) + "px";
            ghost.style.top = (touch.clientY - (element.offsetHeight / 2)) + "px";

            document.body.appendChild(ghost);
            this.state.touchDragGhost = ghost;
        }, { passive: false });

        element.addEventListener("touchmove", (e) => {
            if (!this.state.touchDragItem) return;

            e.preventDefault();

            const touch = e.touches[0];
            const ghost = this.state.touchDragGhost;

            if (ghost) {
                ghost.style.left = (touch.clientX - (ghost.offsetWidth / 2)) + "px";
                ghost.style.top = (touch.clientY - (ghost.offsetHeight / 2)) + "px";
            }
        }, { passive: false });

        element.addEventListener("touchend", (e) => {
            if (!this.state.touchDragItem) return;

            const draggedEl = this.state.touchDragItem;

            if (this.state.touchDragGhost) {
                this.state.touchDragGhost.remove();
                this.state.touchDragGhost = null;
            }
            draggedEl.classList.remove("dragging");
            this.state.touchDragItem = null;

            const touch = e.changedTouches[0];
            const targetEl = document.elementFromPoint(touch.clientX, touch.clientY);

            if (!targetEl) return;

            const targetBuilderElement = targetEl.closest(".builder-element");

            if (targetBuilderElement && targetBuilderElement !== draggedEl) {
                this.performSwap(draggedEl, targetBuilderElement);
            }
        });
    }

    performSwap(draggedEl, targetEl) {
        const container = document.getElementById("builder-container");

        const srcIndex = Array.from(container.children).indexOf(draggedEl);
        const targetIndex = Array.from(container.children).indexOf(targetEl);

        if (srcIndex === -1 || targetIndex === -1 || srcIndex === targetIndex) return;

        const targetClone = targetEl.cloneNode(true);
        const draggedClone = draggedEl.cloneNode(true);

        container.replaceChild(draggedClone, targetEl);
        container.replaceChild(targetClone, draggedEl);

        draggedClone.classList.remove("dragging");
        targetClone.classList.remove("dragging");

        if (draggedClone.classList.contains("icon")) {
            this.makeDraggable(draggedClone);
            this.attachRemoveEvent(draggedClone);
        }
        if (targetClone.classList.contains("icon")) {
            this.makeDraggable(targetClone);
            this.attachRemoveEvent(targetClone);
        }

        this.initDropZones();
        this.updateReceipt();
    }

    initDropZones() {
        const container = document.getElementById("builder-container");

        container.addEventListener("dragover", (e) => {
            e.preventDefault();
        });

        container.querySelectorAll(".builder-element").forEach(el => {
            el.addEventListener("dragover", (e) => {
                e.preventDefault();
                el.classList.add("drag-over");
            });

            el.addEventListener("dragleave", () => {
                el.classList.remove("drag-over");
            });

            el.addEventListener("drop", (e) => {
                e.stopPropagation();
                el.classList.remove("drag-over");

                const container = document.getElementById("builder-container");
                const srcIndex = parseInt(e.dataTransfer.getData("text/plain"), 10);

                if (isNaN(srcIndex) || srcIndex < 0 || srcIndex >= container.children.length) return;

                const draggedEl = container.children[srcIndex];
                const target = el;

                this.performSwap(draggedEl, target);
            });
        });
    }

    attachCategoriesTitles() {
        document.querySelectorAll(".hulkapps_option.categories label").forEach(category => {
            const titleElement = category.querySelector(".swatch_tooltip_title > p");
            if (!titleElement) return;
            const title = titleElement.textContent.trim();
            const newTitle = document.createElement("p");
            newTitle.textContent = title;
            const tooltip = category.querySelector(".hulkapps-tooltip");
            if (tooltip) tooltip.appendChild(newTitle);
        });
    }

    handleAddToCart() {
        document.getElementById("add-to-cart-btn")?.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            this.startLoader();
            await this.generateBraceletImage();
            const form = document.getElementById("add-to-cart-form");
            const formData = new FormData(form);
            try {
                const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    body: formData
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.description || "Error adding to cart");
                }
                this.stopLoader();
                window.location.href = "/cart";
            } catch (error) {
                console.error("Add to cart failed:", error);
            }
        });
    }

    async generateBraceletImage() {
        const charms = Array.from(document.querySelectorAll("#builder-container .builder-element img"));
        if (!charms.length) return;

        const targetHeight = 275;
        const loadedImages = [];

        for (const charm of charms) {
            try {
                const img = await this.loadImage(charm.src);
                const scale = targetHeight / img.naturalHeight;
                const scaledWidth = img.naturalWidth * scale;
                loadedImages.push({ img, width: scaledWidth, height: targetHeight });
            } catch (e) {
                console.error("Could not load image", e);
            }
        }

        const totalWidth = loadedImages.reduce((acc, i) => acc + i.width, 0);
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(totalWidth);
        canvas.height = targetHeight;
        const ctx = canvas.getContext("2d");

        let x = 0;
        for (const { img, width, height } of loadedImages) {
            ctx.drawImage(img, x, 0, width, height);
            x += width;
        }

        const dataURL = canvas.toDataURL("image/png");
        const file = this.dataURLtoFile(dataURL, "bracelet.png");
        const fileInput = this.state.optionSet.querySelector(".bracelet_final input");
        if (fileInput) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            fileInput.files = dataTransfer.files;
        }
    }

    dataURLtoFile(dataurl, filename) {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    loadImage(src) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = src;
        });
    }

    startLoader() {
        this.loaderTimeouts = [];
        this.loaderActive = true;
        const atcBtn = document.getElementById("add-to-cart-btn");
        if (!atcBtn) return;
        atcBtn.classList.add("disabled");
        const loaderElement = atcBtn.querySelector("#loading-overlay");
        if (loaderElement) loaderElement.classList.add("active");
    }

    stopLoader() {
        this.loaderActive = false;
        if (this.loaderTimeouts) {
            this.loaderTimeouts.forEach(id => clearTimeout(id));
            this.loaderTimeouts = [];
        }
        const loaderElement = document.getElementById("loading-overlay");
        if (loaderElement) {
            loaderElement.classList.add("success");
            setTimeout(() => {
                loaderElement.classList.remove("active");
                setTimeout(() => {
                    const atcBtn = document.getElementById("add-to-cart-btn");
                    if (atcBtn) atcBtn.classList.remove("disabled");
                    loaderElement.classList.remove("success");
                }, 250);
            }, 2500);
        }
    }

    showBuilder() {
        const mainWrapper = document.getElementById("main-wrapper");
        if (mainWrapper) mainWrapper.style.opacity = "1";
        const loading = document.getElementById("loading-screen");
        if (loading) loading.style.display = "none";
    }

    handleBuilderStickyPosition() {
        const stickyEl = document.getElementById("builder");
        if (!stickyEl) return;
        const originalOffset = stickyEl.getBoundingClientRect().top + window.scrollY;
        const placeholder = document.createElement("div");
        placeholder.style.height = stickyEl.offsetHeight + "px";
        let isFixed = false;

        window.addEventListener("scroll", () => {
            if (window.scrollY >= originalOffset && !isFixed) {
                stickyEl.style.position = "fixed";
                stickyEl.style.top = "0";
                stickyEl.style.left = "0";
                stickyEl.style.right = "0";
                stickyEl.style.zIndex = "999";
                stickyEl.style.boxShadow = "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px";
                if (stickyEl.parentNode) stickyEl.parentNode.insertBefore(placeholder, stickyEl);
                isFixed = true;
            } else if (window.scrollY < originalOffset && isFixed) {
                stickyEl.style.position = "";
                stickyEl.style.top = "";
                stickyEl.style.left = "";
                stickyEl.style.width = "";
                stickyEl.style.zIndex = "";
                stickyEl.style.boxShadow = "0 20px 30px rgba(0, 0, 0, 0.075), 0 10px 20px rgba(217, 63, 66, 0.05)";
                if (placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
                isFixed = false;
            }
        });
    }

    debounce(func, delay = 10) {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }
}

new Builder();